function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_15660_12491)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip1_15660_12491)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.05469 0.818115H25.8823V17.1818H1.05469V0.818115Z",
  fill: "#012169"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.96417 0.818115L13.4297 6.98857L22.8564 0.818115H25.8823V2.93175L16.5719 9.03402L25.8823 15.1022V17.1818H22.7788L13.4685 11.0795L4.19693 17.1818H1.05469V15.1363L10.3262 9.06812L1.05469 2.99993V0.818115H3.96417Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.503 10.3977L25.8823 15.8181V17.1818L15.3693 10.3977H17.503ZM10.365 11.0795L10.5978 12.2727L3.14952 17.1818H1.05469L10.365 11.0795ZM25.8823 0.818115V0.920388L16.2228 7.32948L16.3004 5.82948L23.9426 0.818115H25.8823ZM1.05469 0.818115L10.3262 6.81812H7.99865L1.05469 2.24993V0.818115Z",
  fill: "#C8102E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.4038 0.818115V17.1818H16.6107V0.818115H10.4038ZM1.05469 6.27266V11.7272H25.8823V6.27266H1.05469Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.05469 7.39766V10.6704H25.8823V7.39766H1.05469ZM11.6452 0.818115V17.1818H15.3693V0.818115H11.6452Z",
  fill: "#C8102E"
})));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 0.96875,
  y: 0.5,
  width: 25,
  height: 17,
  rx: 1.5,
  stroke: "#E0E4E8"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_15660_12491"
}, /*#__PURE__*/React.createElement("rect", {
  x: 1.46875,
  y: 1,
  width: 24,
  height: 16,
  rx: 1,
  fill: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip1_15660_12491"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24.8276,
  height: 16.3636,
  fill: "white",
  transform: "translate(1.05469 0.818115)"
})));

function SvgGb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 18,
    viewBox: "0 0 27 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGb);
export default __webpack_public_path__ + "static/media/GB.66ce2ad8.svg";
export { ForwardRef as ReactComponent };